import { InputNumber } from "antd"

type Props = {
  value: number
  money?: boolean
  onChange: (value: number) => void
  disabled?: boolean
  min?: number
}

const BudgetInputNumber = ({ value, money = false, onChange, disabled = false, min = 0 }: Props) => {
  return (
    <InputNumber
      addonBefore={money && '$'}
      value={value}
      formatter={value => `${value?.toLocaleString()}`}
      min={min}
      style={{ width: '100%' }}
      onChange={value => onChange(value ?? 0)}
      disabled={disabled}
    />
  )
}
export default BudgetInputNumber
